export default "__VITE_ASSET__DxFFkL1t__"